import React from "react";
import ApiCommunityDirectoryPage from "./ApiCommunityDirectoryPage";

export default function Trinidadian() {
  return (
    <ApiCommunityDirectoryPage
      community="Trinidadian"
      eyebrow="Trinidadian community guide"
      title="Trinidadian favorites, businesses, and local essentials in San Antonio."
      
      tags={["Trinidadian community", "San Antonio", "Local businesses"]}
      claimText="Want your business featured in the Trinidadian community guide?"
      modalIdPrefix="trinidadian-directory"
    />
  );
}
